__turbopack_context__.v({
  "ol": "qnqlxa_ol",
  "ul": "qnqlxa_ul",
});
